import React, { useState } from 'react';
import creditzVid from '../../assets/video/Chain-swing.webm';
import creditzVid1 from '../../assets/video/studio-guy.mp4';
import bg from '../../assets/images/branding/bg.png';
import { FaFacebookF, FaInstagram, FaTwitter } from 'react-icons/fa';
import { withRouter } from "react-router-dom";
import logo from "../../assets/images/branding/CREDITZ-WHITE.png";
import styles from "./style.module.scss";


function Welcome() {
    return (
        <div className={styles.welcome} scroll="no">
            <section className={styles.showcase}>
                <video playsInline loop autoPlay muted autobuffer poster={bg} className={styles.video}>
                    <source src={creditzVid1} type="video/mp4"/>
                    <source src={creditzVid} type="video/webm"/>
                    <img src={bg} alt=""/>
                </video>
                <div className={styles.overlay}></div>
                <div className={styles.text}>
                    <img src={logo} alt="Logo" className={styles.logo} />
                    <h2>Find & Be Found in Music</h2>
                    <a href='/Login'>Explore</a>
                </div>
                <ul className={styles.social}>
                    <li>
                        <a href='https://www.facebook.com/creditzmusic'>
                            <FaFacebookF />
                        </a>
                    </li>
                    <li>
                        <a href='https://twitter.com/CreditzMusic'>
                            <FaTwitter />
                        </a>
                    </li>
                    <li>
                        <a href='https://www.instagram.com/creditzmusic/'>
                            <FaInstagram />
                        </a>
                    </li>
                </ul>
            </section>
        </div>
    );
};

export default withRouter(Welcome);
